import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import {
  GroupedSpecialization,
  LearningTreeSpecialization,
} from '../../../services/learning-facade.service';

@Component({
  selector: 'app-learning-tree',
  templateUrl: './learning-tree.component.html',
  styleUrls: ['./learning-tree.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningTreeComponent {

  @Input() groupedSpecializations: GroupedSpecialization[] = [];
  @Input() isLoading: boolean = false;

  @Output() specializationSelected = new EventEmitter<string>();

  expandedGroups = new Set<string>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.cdr.detectChanges();
  }

  trackByGroupId(index: number, item: GroupedSpecialization): string {
    return item ? item.id : '';
  }

  trackBySpecId(index: number, item: LearningTreeSpecialization): string {
    return item ? item.id : '';
  }

  onSpecClick(specId: string): void {
    this.specializationSelected.emit(specId);
  }

  isGroupExpanded(groupId: string): boolean {
    return this.expandedGroups.has(groupId);
  }

  toggleGroup(groupId: string): void {
    if (this.isGroupExpanded(groupId)) {
      this.expandedGroups.delete(groupId);
    } else {
      this.expandedGroups.add(groupId);
    }
    this.cdr.markForCheck();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/learning-tree/learning-tree.component.ts